import { render } from "./ArticleDetail.vue?vue&type=template&id=38b0cac4&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&lang=js"

import "./ArticleDetail.vue?vue&type=style&index=0&id=38b0cac4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38b0cac4"

export default script